// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"175":"83d64f2e","233":"c2e995d5","369":"a055b46b","936":"49483b8e"}[chunkId] + ".css";
};